import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'parquesnacionales/pdf';
const CONTEXT_BASE_HTML_PATH = 'parquesnacionales/html';
const CONTEXT_SINGLE_BASE_PATH = 'parquesnacionales/pdfindividual';
// #endregion

// #region Public functions
async function getNationalParkPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchNationalParkPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchNationalParkHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getNationalParkPdf,
  searchNationalParkPdf,
  searchNationalParkHtml,
};
